import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AttendanceContractType } from '../../models/attendance-contract-type.model';
import { AttendanceContractTypeEnum } from '../../enums/attendance-contract-type.enum';

@Injectable({
  providedIn: 'root'
})
export class AttendanceContractTypeService {
  constructor() {}

  getAttendanceContractTypes(): AttendanceContractType[] {
    return Object.keys(AttendanceContractTypeEnum)
    .filter(key => !isNaN(Number(AttendanceContractTypeEnum[key])))
    .map(key => new AttendanceContractType(Number(AttendanceContractTypeEnum[key]), key));
  }
}
